import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=08e37c0a&scoped=true&"
import script from "./importFile.vue?vue&type=script&lang=js&"
export * from "./importFile.vue?vue&type=script&lang=js&"
import style0 from "./importFile.vue?vue&type=style&index=0&id=08e37c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e37c0a",
  null
  
)

export default component.exports